<div class="task-panel-wrapper">

  <!-- Task Header -->
  <div class="task-header-bar">
    <h1 class="page-title">Task <span class="count-parens">({{ formatCount(totalTaskCount) }})</span></h1>

    <div class="header-actions">
      <div class="switch-tabs">
        <button type="button" [class.active]="activeViewMode === 'normal'" (click)="setActiveViewMode('normal')">Normal</button>
        <button type="button" [class.active]="activeViewMode === 'tags'" (click)="setActiveViewMode('tags')">Tags</button>
      </div>

      <!-- New Task Button -->
      <button class="btn-new-task" *ngIf="config.showCreateButton" (click)="openCreateTaskDialog()">
        <i class="ri-add-line"></i>
        New Task
      </button>

      <!-- Filter Button -->
      <button class="btn-filter" *ngIf="config.showFilters" (click)="toggleFilters()" [class.has-filters]="activeFiltersCount > 0" title="Filter">
        <i class="ri-filter-line"></i>
      </button>
    </div>
  </div>

  <!-- Filter Overlay -->
  <ng-container *ngIf="showFilters && config.showFilters">
    <div class="filter-drawer">
      <app-task-filter
        [availableStatuses]="availableStatuses"
        [availableTags]="availableTags"
        [availableUsers]="availableUsers"
        [initialFilter]="currentFilters"
        (filterChange)="onFiltersChanged($event)"
        (clearFilters)="onClearFilters()"
        (close)="toggleFilters()" />
    </div>
  </ng-container>

  <!-- Content Area -->
  <div class="task-content-area">

    <!-- Error State -->
    <div class="error-state" *ngIf="error && !loading">
      <div class="error-content">
        <i class="pi pi-exclamation-triangle" style="font-size: 2rem; color: #ef4444;"></i>
        <h3>Unable to Load Tasks</h3>
        <p>{{ error }}</p>
        <button type="button" class="p-button p-button-outlined" (click)="loadTasks()">
          <i class="pi pi-refresh"></i> Retry
        </button>
      </div>
    </div>

    <!-- Task Views -->
    <div class="task-views" *ngIf="!loading && !error">

      @if (activeViewMode === 'tags') {

        <!-- Tags Board Empty State -->
        <div class="empty-state" *ngIf="!hasTagViewContent">
          <div class="empty-content">
            <i class="pi pi-tag" style="font-size: 3rem; color: #6b7280;"></i>
            <h3>No tagged tasks</h3>
            <p>Assign tags to tasks to see them grouped here</p>
          </div>
        </div>

        <!-- Tags Kanban Board -->
        <div class="kanban-board" *ngIf="hasTagViewContent">
          <div class="kanban-columns">

            <!-- Virtual Columns: Overdue, Due Today -->
            @for (vCol of kanbanBoard?.virtualColumns; track vCol.statusName) {
              <div class="kanban-column">
                <div class="column-header" [style.background-color]="getVirtualColumnColor(vCol.statusName)">
                  <span class="col-name">{{ vCol.statusName }}</span>
                  <span class="col-count">{{ formatCount(vCol.tasks.length) }}</span>
                </div>
                <div class="column-body">
                  @for (task of vCol.tasks; track task.taskId) {
                    <div class="task-card virtual-card"
                         [class.overdue-card]="vCol.statusName === 'Overdue'"
                         [class.due-today-card]="vCol.statusName === 'Due Today'"
                         (click)="onTaskClick(task)">
                      <div class="card-stripe" [style.background-color]="getVirtualColumnColor(vCol.statusName)"></div>
                      <div class="card-title">{{ task.title }}</div>
                      <div class="card-context" *ngIf="getTaskContextLabel(task)" [pTooltip]="getTaskContextLabel(task)" tooltipPosition="top">{{ getTaskContextLabel(task) }}</div>
                      <div class="card-subtitle">
                        <span *ngIf="task.description">{{ task.description }}</span>
                        <span class="sep-dot" *ngIf="task.description && task.assignedToName">â€¢</span>
                        <span *ngIf="task.assignedToName">{{ task.assignedToName }}</span>
                      </div>
                      <div class="card-footer-row">
                        <span class="card-date">{{ formatCardDate(task.endDate) }}</span>
                        @if (vCol.statusName === 'Overdue') {
                          <span class="overdue-badge" style="background-color: #ed1c4d;">
                            {{ getDaysOverdue(task.endDate!) }} days overdue
                          </span>
                        }
                        @if (vCol.statusName === 'Due Today') {
                          <span class="overdue-badge" style="background-color: #e09500;">
                            Due today
                          </span>
                        }
                      </div>
                    </div>
                  }
                  <div class="empty-column" *ngIf="vCol.tasks.length === 0">
                    <i class="pi pi-check-circle"></i>
                    <span>No tasks</span>
                  </div>
                </div>
              </div>
            }

            @for (group of tagKanbanColumns; track group.tag.tagId) {
              <div class="kanban-column">
                <div class="column-header tag-column-header">
                  <span class="col-name">{{ group.tag.tagName }}</span>
                  <span class="col-count">{{ formatCount(group.tasks.length) }}</span>
                </div>
                <div class="column-body">
                  @for (task of group.tasks; track task.taskId) {
                    <div class="task-card regular-card" (click)="onTaskClick(task)">
                      <div class="card-title">{{ task.title }}</div>
                      <div class="card-context" *ngIf="getTaskContextLabel(task)" [pTooltip]="getTaskContextLabel(task)" tooltipPosition="top">{{ getTaskContextLabel(task) }}</div>
                      <div class="card-subtitle">
                        <span *ngIf="task.description">{{ task.description }}</span>
                        <span class="sep-dot" *ngIf="task.description && task.assignedToName">•</span>
                        <span *ngIf="task.assignedToName">{{ task.assignedToName }}</span>
                      </div>
                      <div class="card-footer-row">
                        <span class="card-date">{{ formatCardDate(task.endDate) }}</span>
                      </div>
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        </div>

      } @else {

      @if (currentView === 'kanban') {

         <!-- Kanban Empty State -->
        <div class="empty-state" *ngIf="!kanbanBoard || (!kanbanBoard.statusColumns?.length && !kanbanBoard.virtualColumns?.length)">
          <div class="empty-content">
            <i class="pi pi-inbox" style="font-size: 3rem; color: #6b7280;"></i>
            <h3>No tasks found</h3>
            <p>Create your first task to get started</p>
            <button *ngIf="config.showCreateButton" class="btn-new-task" (click)="openCreateTaskDialog()">
              <i class="ri-add-line"></i> Create Task
            </button>
          </div>
        </div>

        <!-- Kanban Board -->
        <div class="kanban-board" *ngIf="kanbanBoard">
          <div class="kanban-columns">

            <!-- Virtual Columns: Overdue, Due Today (separate columns) -->
            @for (vCol of kanbanBoard.virtualColumns; track vCol.statusName) {
              <div class="kanban-column">
                <div class="column-header" [style.background-color]="getVirtualColumnColor(vCol.statusName)">
                  <span class="col-name">{{ vCol.statusName }}</span>
                  <span class="col-count">{{ formatCount(vCol.tasks.length) }}</span>
                </div>
                <div class="column-body">
                  @for (task of vCol.tasks; track task.taskId) {
                    <div class="task-card virtual-card"
                         [class.overdue-card]="vCol.statusName === 'Overdue'"
                         [class.due-today-card]="vCol.statusName === 'Due Today'"
                         (click)="onTaskClick(task)">
                      <div class="card-stripe" [style.background-color]="getVirtualColumnColor(vCol.statusName)"></div>
                      <div class="card-title">{{ task.title }}</div>
                      <div class="card-context" *ngIf="getTaskContextLabel(task)" [pTooltip]="getTaskContextLabel(task)" tooltipPosition="top">{{ getTaskContextLabel(task) }}</div>
                      <div class="card-subtitle">
                        <span *ngIf="task.description">{{ task.description }}</span>
                        <span class="sep-dot" *ngIf="task.description && task.assignedToName">•</span>
                        <span *ngIf="task.assignedToName">{{ task.assignedToName }}</span>
                      </div>
                      <div class="card-footer-row">
                        <span class="card-date">{{ formatCardDate(task.endDate) }}</span>
                        @if (vCol.statusName === 'Overdue') {
                          <span class="overdue-badge" style="background-color: #ed1c4d;">
                            {{ getDaysOverdue(task.endDate!) }} days overdue
                          </span>
                        }
                        @if (vCol.statusName === 'Due Today') {
                          <span class="overdue-badge" style="background-color: #e09500;">
                            Due today
                          </span>
                        }
                      </div>
                    </div>
                  }
                  <div class="empty-column" *ngIf="vCol.tasks.length === 0">
                    <i class="pi pi-check-circle"></i>
                    <span>No tasks</span>
                  </div>
                </div>
              </div>
            }

            <!-- Regular Status Columns -->
            @for (col of kanbanBoard.statusColumns; track col.statusId) {
              <div class="kanban-column">
                <div class="column-header" [style.background-color]="col.statusColor">
                  <span class="col-name">{{ col.statusName }}</span>
                  <span class="col-count">{{ formatCount(col.tasks.length) }}</span>
                </div>
                <div class="column-body">
                  @for (task of col.tasks; track task.taskId) {
                    <div class="task-card regular-card" (click)="onTaskClick(task)">
                      <div class="card-title">{{ task.title }}</div>
                      <div class="card-context" *ngIf="getTaskContextLabel(task)" [pTooltip]="getTaskContextLabel(task)" tooltipPosition="top">{{ getTaskContextLabel(task) }}</div>
                      <div class="card-subtitle">
                        <span *ngIf="task.description">{{ task.description }}</span>
                        <span class="sep-dot" *ngIf="task.description && task.assignedToName">•</span>
                        <span *ngIf="task.assignedToName">{{ task.assignedToName }}</span>
                      </div>
                      <div class="card-footer-row">
                        <span class="card-date">{{ formatCardDate(task.endDate) }}</span>
                      </div>
                    </div>
                  }
                  <div class="empty-column" *ngIf="col.tasks.length === 0">
                    <i class="pi pi-inbox"></i>
                    <span>No tasks</span>
                  </div>
                </div>
              </div>
            }

          </div>
        </div>

       

      } @else {
        <!-- List View -->
        <app-task-list
          [tasks]="filteredTasks"
          [loading]="loadingMore"
          [hasMoreTasks]="hasMoreTasks"
          [showCreateButton]="!!config.showCreateButton"
          [showDescription]="true"
          [showStatus]="true"
          [showTags]="true"
          [draggable]="false"
          (taskEdit)="onTaskEdit($event)"
          (taskDelete)="onTaskDelete($event)"
          (statusChange)="onTaskStatusChange($event)"
          (taskClick)="onTaskClick($event)"
          (createTask)="onTaskCreate()"
          (loadMore)="loadMoreTasks()" />
      }

      } <!-- end @else normal -->

    </div>
  </div>

</div>

<!-- Task Form Dialog -->
<app-task-form
  [visible]="showTaskForm"
  [projectId]="projectId"
  [blockScheduleId]="blockScheduleId"
  [projectTemplateId]="projectTemplateId"
  [availableStatuses]="availableStatuses"
  [availableTags]="availableTags"
  [availableUsers]="availableUsers"
  [availableParentTasks]="availableParentTasks"
  [editTask]="editingTask"
  [defaultValues]="taskFormDefaults"
  [loading]="submittingTask"
  [readOnly]="taskFormReadOnly"
  (visibleChange)="showTaskForm = $event"
  (taskSubmit)="onTaskSubmit($event)"
  (cancel)="onTaskFormCancel()" />

<!-- Comments Dialog -->
<app-task-comments
  [visible]="showComments"
  [taskId]="selectedTaskId"
  [comments]="selectedTaskComments"
  [currentUser]="currentUser"
  [submittingComment]="submittingComment"
  (visibleChange)="showComments = $event"
  (commentSubmit)="onCommentSubmit($event)" />
